export default "__VITE_ASSET__m6F37HGW__"